'use strict';

module.exports = {
    113: {
        icon: 'sunny',
        desc: gettext('Clear/Sunny')
    },
    116: {
        icon: 'partly.cloudy',
        desc: gettext('Partly cloudy')
    },
    119: {
        icon: 'partly.cloudy',
        desc: gettext('Partly cloudy')
    },
    122: {
        icon: 'overcast',
        desc: gettext('Overcast')
    },
    143: {
        icon: 'fog',
        desc: gettext('Mist')
    },
    176: {
        icon: 'rain',
        desc: gettext('Patchy rain nearby')
    },
    179: {
        icon: 'snow',
        desc: gettext('Patchy snow nearby')
    },
    182: {
        icon: 'sleet',
        desc: gettext('Patchy sleet nearby')
    },
    185: {
        icon: 'drizzle',
        desc: gettext('Patchy freezing drizzle nearby')
    },
    200: {
        icon: 'storm',
        desc: gettext('Thundery outbreaks in nearby')
    },
    227: {
        icon: 'blizzard',
        desc: gettext('Blowing snow')
    },
    230: {
        icon: 'blizzard',
        desc: gettext('Blizzard')
    },
    248: {
        icon: 'fog',
        desc: gettext('Fog')
    },
    260: {
        icon: 'fog',
        desc: gettext('Freezing fog')
    },
    263: {
        icon: 'drizzle',
        desc: gettext('Patchy light drizzle')
    },
    266: {
        icon: 'drizzle',
        desc: gettext('Light drizzle')
    },
    281: {
        icon: 'drizzle',
        desc: gettext('Freezing drizzle')
    },
    284: {
        icon: 'drizzle',
        desc: gettext('Heavy freezing drizzle')
    },
    293: {
        icon: 'rain',
        desc: gettext('Patchy light rain')
    },
    296: {
        icon: 'rain',
        desc: gettext('Light rain')
    },
    299: {
        icon: 'rain',
        desc: gettext('Moderate rain at times')
    },
    302: {
        icon: 'rain',
        desc: gettext('Moderate rain')
    },
    305: {
        icon: 'shower',
        desc: gettext('Heavy rain at times')
    },
    308: {
        icon: 'shower',
        desc: gettext('Heavy rain')
    },
    311: {
        icon: 'rain',
        desc: gettext('Light freezing rain')
    },
    314: {
        icon: 'shower',
        desc: gettext('Moderate or Heavy freezing rain')
    },
    317: {
        icon: 'sleet',
        desc: gettext('Light sleet')
    },
    320: {
        icon: 'sleet',
        desc: gettext('Moderate or heavy sleet')
    },
    323: {
        icon: 'snow',
        desc: gettext('Patchy light snow')
    },
    326: {
        icon: 'snow',
        desc: gettext('Light snow')
    },
    329: {
        icon: 'snow',
        desc: gettext('Patchy moderate snow')
    },
    332: {
        icon: 'snow',
        desc: gettext('Moderate snow')
    },
    335: {
        icon: 'snowfall',
        desc: gettext('Patchy heavy snow')
    },
    338: {
        icon: 'snowfall',
        desc: gettext('Heavy snow')
    },
    350: {
        icon: 'pellets',
        desc: gettext('Ice pellets')
    },
    353: {
        icon: 'rain',
        desc: gettext('Light rain shower')
    },
    356: {
        icon: 'shower',
        desc: gettext('Moderate or heavy rain shower')
    },
    359: {
        icon: 'shower',
        desc: gettext('Torrential rain shower')
    },
    362: {
        icon: 'sleet',
        desc: gettext('Light snow shower')
    },
    365: {
        icon: 'sleet',
        desc: gettext('Moderate or heavy sleet showers')
    },
    368: {
        icon: 'sleet',
        desc: gettext('Light snow showers')
    },
    371: {
        icon: 'sleet',
        desc: gettext('Moderate or heavy snow showers')
    },
    374: {
        icon: 'light.pellets',
        desc: gettext('Light shower of ice pellets')
    },
    377: {
        icon: 'heavy.pellets',
        desc: gettext('Moderate or heavy showers of ice pellets')
    },
    386: {
        icon: 'rain',
        desc: gettext('Patchy light rain in area with thunder')
    },
    389: {
        icon: 'shower',
        desc: gettext('Moderate or heavy rain in area with thunder')
    },
    392: {
        icon: 'snow',
        desc: gettext('Patchy light snow in area with thunder')
    },
    395: {
        icon: 'snowfall',
        desc: gettext('Moderate or heavy snow in area with thunder')
    }
};
